<template>
	<div :class="{'has-error': mensagemErro}">
		<label>
			<slot name="info" /> <span v-if="obrigatorio">*</span> {{ label }}:
		</label>
		<template v-if="!carregando">
			<select
				v-if="!vueSelect"
				:disabled="disabled"
				:value="value.model"
				@input="emitValue('input', $event.target.value)"
				@change="emitValue('change', $event.target.value)"
				class="form-control input-ssm"
			>
				<option value="" :disabled="disabledDefault">
					{{ _traducao('global', opcaoDefault).toUpperCase() }}
				</option>
				<option
					v-for="(opcao, index) in listaOpcoes"
					:key="`select-${opcao[campoValor]}-${index}`"
					:value="opcao[campoValor]"
				>
					{{ opcao[labelOption] ? opcao[labelOption].toUpperCase() : '' }}
				</option>
			</select>
			<v-select
				v-else
				:label="labelOption"
				class="form-control input-sm"
				@input="(value) => emitValue('input', value)"
				@change="(value) => emitValue('change', value)"
				:disabled="disabled"
				:options="listaOpcoes"
				:value="value.model"
			>
				<template #option="props">
					<slot name="vue-select">
						<div>{{ props[labelOption] }}</div>
					</slot>
				</template>
			</v-select>

			<p class="help-block" v-show="mensagemErro">{{ mensagemErro }}</p>
			<p class="text-info" v-show="mensagemInformacao">
				{{ mensagemInformacao }}
			</p>
		</template>
		<template v-else>
			<flCarregando />
		</template>
	</div>
</template>

<script>
import mixinInputModel from './mixinInputModel'
export default {
	mixins: [mixinInputModel],
	props: {
		labelOption: {
			type: String,
			default: 'label'
		},

		campoValor: {
			type: String,
			default: 'value'
		},

		opcoes: {
			type: Array,
			required: false,
			default: function () {
				return []
			}
		},

		opcoesObjeto: {
			type: Array,
			required: false,
			default: function () {
				return []
			}
		},

		opcaoDefault: {
			required: false,
			default: 'escolha',
			type: String
		},

		disabledDefault: {
			type: Boolean,
			default: false
		},

		vueSelect: {
			type: Boolean,
			default: false
		},

		carregando: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	computed: {
		listaOpcoes() {
			let retorno = []
			if (this.opcoesObjeto.length > 0) {
				retorno = this.opcoesObjeto
			} else {
				retorno = this.opcoes.map((opcao) => {
					return {
						label: opcao,
						value: opcao
					}
				})
			}

			this.$forceUpdate()

			return retorno
		}
	}
}
</script>